import React, { Component } from "react";
import axios from "axios";
import "./AddNewProduct.css";
import VendorSidebar from "./VendorSideBar";

class AddNewProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      category: "",
      subCategory: "",
      costPrice: "",
      margin: "",
      stock: "",
      description: "",
      salesPrice: "",
      image: null, // Changed from images array to single image
      imagePreviewUrl: "", // Changed from array to single URL
      discount: "",
      discountedPrice: "",
      categories: [],
      subCategories: [],
      message: "",
      vendorId: 1,
      delivery_charges: "",
    };
    console.log("Constructor: Initialized state", this.state);
  }

  componentDidMount() {
    console.log("ComponentDidMount: Fetching categories");
    this.fetchCategories();
  }

  fetchCategories = () => {
    axios
      .get("https://earnistamart.online/getcategories")
      .then((response) => {
        console.log("FetchCategories: Response received", response.data);
        const categories = response.data.posts.map((cat) => ({
          id: cat._id,
          name: cat.name,
          subcategories: cat.subcategories.map((subCat) => ({
            id: subCat._id,
            name: subCat.name,
          })),
        }));
        this.setState({ categories }, () =>
          console.log("FetchCategories: State updated", this.state.categories)
        );
      })
      .catch((error) => {
        console.error("FetchCategories: Error fetching categories", error);
      });
  };

  handleCategoryChange = (e) => {
    const selectedCategory = this.state.categories.find(
      (cat) => cat.id === parseInt(e.target.value)
    );
    console.log("HandleCategoryChange: Selected category", selectedCategory);
    this.setState(
      {
        category: selectedCategory.id,
        subCategories: selectedCategory.subcategories,
        subCategory: "",
      },
      () => console.log("HandleCategoryChange: State updated", this.state)
    );
  };

  handleSubCategoryChange = (e) => {
    const selectedSubCategory = this.state.subCategories.find(
      (subCat) => subCat.name === e.target.value
    );
    console.log(
      "HandleSubCategoryChange: Selected sub-category",
      selectedSubCategory
    );
    if (selectedSubCategory) {
      this.setState(
        {
          subCategory: selectedSubCategory.name,
        },
        () =>
          console.log(
            "HandleSubCategoryChange: Sub-category state updated",
            this.state.subCategory
          )
      );
    } else {
      this.setState(
        {
          subCategory: "",
        },
        () =>
          console.log(
            "HandleSubCategoryChange: Sub-category reset",
            this.state.subCategory
          )
      );
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    console.log("HandleChange: Input change detected", name, value);
    this.setState({ [name]: value }, () => {
      console.log("HandleChange: State updated", this.state);
      if (name === "margin" || name === "costPrice") {
        this.updateSalesPrice();
      } else if (name === "discount") {
        this.updateDiscountedPrice();
      }
    });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0]; // Single file
    console.log("HandleImageChange: File selected", file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState(
          {
            image: file, // Set single image
            imagePreviewUrl: reader.result, // Set single preview URL
          },
          () => console.log("HandleImageChange: Image state updated", this.state)
        );
      };
      reader.readAsDataURL(file);
    }
  };

  updateSalesPrice = () => {
    const { costPrice, margin } = this.state;
    console.log("UpdateSalesPrice: Calculating sales price", costPrice, margin);
    if (costPrice && margin) {
      const salesPrice = (parseFloat(costPrice) + parseFloat(margin)).toFixed(
        2
      );
      this.setState({ salesPrice }, () => {
        console.log("UpdateSalesPrice: Sales price updated", this.state.salesPrice);
        this.updateDiscountedPrice();
      });
    }
  };

  updateDiscountedPrice = () => {
    const { salesPrice, discount } = this.state;
    console.log("UpdateDiscountedPrice: Calculating discounted price", salesPrice, discount);
    if (salesPrice && discount) {
      const discountedPrice = (
        salesPrice -
        salesPrice * (parseFloat(discount) / 100)
      ).toFixed(2);
      this.setState({ discountedPrice }, () =>
        console.log("UpdateDiscountedPrice: Discounted price updated", this.state.discountedPrice)
      );
    } else {
      this.setState({ discountedPrice: salesPrice }, () =>
        console.log("UpdateDiscountedPrice: Discounted price set to sales price", this.state.discountedPrice)
      );
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("HandleSubmit: Form submission started");

    const {
      name,
      category,
      subCategory,
      costPrice,
      margin,
      stock,
      description,
      salesPrice,
      discountedPrice,
      image, // Single image
      vendorId,
      delivery_charges,
    } = this.state;

    console.log("HandleSubmit: Current state", this.state);

    const parsedStock = parseInt(stock, 10);
    if (isNaN(parsedStock)) {
      this.setState({ message: "Stock must be a valid number" }, () =>
        console.error("HandleSubmit: Invalid stock input")
      );
      return;
    }

    const productData = new FormData();
    productData.append("name", name);
    productData.append("category_id", category);
    productData.append("subcategory_name", subCategory);
    productData.append("costprice", parseFloat(costPrice));
    productData.append("margin", parseFloat(margin));
    productData.append("stock", parsedStock);
    productData.append("description", description);
    productData.append("vendor_id", vendorId);
    productData.append("discount", parseFloat(this.state.discount || 0));
    productData.append("delivery_charges", parseFloat(delivery_charges || 0));

    if (image) {
      productData.append("image", image); // Single image
    }

    console.log("HandleSubmit: Form data prepared", productData);

    axios
      .post("https://earnistamart.online/products", productData)
      .then((response) => {
        console.log("HandleSubmit: Success response", response.data);
        this.setState({
          message: "Product added successfully!",
          name: "",
          category: "",
          subCategory: "",
          costPrice: "",
          margin: "",
          stock: "",
          description: "",
          salesPrice: "",
          image: null, // Reset single image
          imagePreviewUrl: "", // Reset preview URL
          discount: "",
          discountedPrice: "",
          subCategories: [],
          delivery_charges: "",
        }, () => console.log("HandleSubmit: State reset after submission", this.state));

        // Trigger the callback to update dashboard stats
        if (this.props.onProductAdded) {
          this.props.onProductAdded();
        }
      })
      .catch((error) => {
        console.error("HandleSubmit: Error adding product", error);
        const errorMsg =
          error.response?.data?.message ||
          "An error occurred while adding the product.";
        this.setState({ message: `Error: ${errorMsg}` }, () =>
          console.log("HandleSubmit: Error message state updated", this.state.message)
        );
      });
  };

  render() {
    const {
      categories,
      subCategories,
      category,
      subCategory,
      salesPrice,
      discountedPrice,
      imagePreviewUrl, // Single preview URL
      message,
      stock,
      delivery_charges,
    } = this.state;

    console.log("Render: Current render state", this.state);

    return (
      <div className="vendor-dashboard add-product-dashboard">
        <VendorSidebar />
        <div className="add-product-container">
          <div className="add-product-card">
            <h2 className="text-center mb-4">Add New Product</h2>

            {message && <div className="alert alert-info">{message}</div>}

            <form onSubmit={this.handleSubmit}>
              <div className="form-group input-icon">
                <i className="fas fa-tag"></i>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="category">Category</label>
                <select
                  className="form-control form-select"
                  id="category"
                  name="category"
                  value={category}
                  onChange={this.handleCategoryChange}
                  required
                >
                  <option value="" disabled>
                    Select Category
                  </option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="subCategory">Sub-Category</label>
                <select
                  className="form-control form-select"
                  id="subCategory"
                  name="subCategory"
                  value={subCategory}
                  onChange={this.handleSubCategoryChange}
                  required
                  disabled={!category}
                >
                  <option value="" disabled>
                    Select Sub-Category
                  </option>
                  {subCategories.map((subCat) => (
                    <option key={subCat.id} value={subCat.name}>
                      {subCat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-dollar-sign"></i>
                <label htmlFor="costPrice">Cost Price</label>
                <input
                  type="number"
                  className="form-control"
                  id="costPrice"
                  name="costPrice"
                  value={this.state.costPrice}
                  onChange={this.handleChange}
                  required
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-percent"></i>
                <label htmlFor="margin">Margin</label>
                <input
                  type="number"
                  className="form-control"
                  id="margin"
                  name="margin"
                  value={this.state.margin}
                  onChange={this.handleChange}
                  required
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-warehouse"></i>
                <label htmlFor="stock">Stock</label>
                <input
                  type="number"
                  className="form-control"
                  id="stock"
                  name="stock"
                  value={stock}
                  onChange={this.handleChange}
                  required
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-dollar-sign"></i>
                <label htmlFor="salesPrice">Sales Price</label>
                <input
                  type="text"
                  className="form-control"
                  id="salesPrice"
                  value={salesPrice}
                  readOnly
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-percent"></i>
                <label htmlFor="discount">Discount (%)</label>
                <input
                  type="number"
                  className="form-control"
                  id="discount"
                  name="discount"
                  value={this.state.discount}
                  onChange={this.handleChange}
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-dollar-sign"></i>
                <label htmlFor="discountedPrice">Discounted Price</label>
                <input
                  type="text"
                  className="form-control"
                  id="discountedPrice"
                  value={discountedPrice}
                  readOnly
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-shipping-fast"></i>
                <label htmlFor="delivery_charges">Delivery Charges</label>
                <input
                  type="number"
                  className="form-control"
                  id="delivery_charges"
                  name="delivery_charges"
                  value={delivery_charges}
                  onChange={this.handleChange}
                />
              </div>

              <div className="form-group input-icon">
                <i className="fas fa-image"></i>
                <label htmlFor="image">Product Image</label>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  name="image"
                  onChange={this.handleImageChange}
                  required
                />
                <div className="image-preview-container mt-2">
                  {imagePreviewUrl && (
                    <img
                      src={imagePreviewUrl}
                      alt="Preview"
                      className="img-thumbnail"
                      style={{ maxWidth: "200px", marginRight: "10px" }}
                    />
                  )}
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-block mt-4">
                Add Product
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default AddNewProduct;
